// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Указываем box sizing */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* Убираем внутренние отступы */
ul[class],
ol[class] {
  padding: 0;
}

/* Убираем внешние отступы */
body,
h1,
h2,
h3,
h4,
p,
ul[class],
ol[class],
li,
figure,
figcaption,
blockquote,
dl,
dd {
  margin: 0;
}

/* Выставляем основные настройки по-умолчанию для body */
body {
  min-height: 100vh;
  scroll-behavior: smooth;
  text-rendering: optimizeSpeed;
  line-height: 1.5;
}

/* Удаляем стандартную стилизацию для всех ul и il, у которых есть атрибут class*/
ul[class],
ol[class] {
  list-style: none;
}

/* Элементы a, у которых нет класса, сбрасываем до дефолтных стилей */
a:not([class]) {
  text-decoration-skip-ink: auto;
}

/* Упрощаем работу с изображениями */
img {
  max-width: 100%;
  display: block;
}

/* Указываем понятную периодичность в потоке данных у article*/
article > * + * {
  margin-top: 1em;
}

/* Наследуем шрифты для инпутов и кнопок */
input,
button,
textarea,
select {
  font: inherit;
}

/* Удаляем все анимации и переходы для людей, которые предпочитай их не использовать */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
body {
  font-family: "Inter", sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/styles/index.scss","webpack://./src/styles/reset.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,yBAAA;AACA;;;EAGE,sBAAA;ADEF;;ACCA,+BAAA;AACA;;EAEE,UAAA;ADEF;;ACCA,4BAAA;AACA;;;;;;;;;;;;;;EAcE,SAAA;ADEF;;ACCA,wDAAA;AACA;EACE,iBAAA;EACA,uBAAA;EACA,6BAAA;EACA,gBAAA;ADEF;;ACCA,iFAAA;AACA;;EAEE,gBAAA;ADEF;;ACCA,qEAAA;AACA;EACE,8BAAA;ADEF;;ACCA,oCAAA;AACA;EACE,eAAA;EACA,cAAA;ADEF;;ACCA,8DAAA;AACA;EACE,eAAA;ADEF;;ACCA,0CAAA;AACA;;;;EAIE,aAAA;ADEF;;ACCA,sFAAA;AACA;EACE;IACE,qCAAA;IACA,uCAAA;IACA,sCAAA;IACA,gCAAA;EDEF;AACF;AA3EA;EACE,gCEqCiB;AFwCnB","sourcesContent":["@import \"reset.scss\";\n@import 'variables.scss';\n\nbody {\n  font-family: $font-family-main;\n}","/* Указываем box sizing */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n/* Убираем внутренние отступы */\nul[class],\nol[class] {\n  padding: 0;\n}\n\n/* Убираем внешние отступы */\nbody,\nh1,\nh2,\nh3,\nh4,\np,\nul[class],\nol[class],\nli,\nfigure,\nfigcaption,\nblockquote,\ndl,\ndd {\n  margin: 0;\n}\n\n/* Выставляем основные настройки по-умолчанию для body */\nbody {\n  min-height: 100vh;\n  scroll-behavior: smooth;\n  text-rendering: optimizeSpeed;\n  line-height: 1.5;\n}\n\n/* Удаляем стандартную стилизацию для всех ul и il, у которых есть атрибут class*/\nul[class],\nol[class] {\n  list-style: none;\n}\n\n/* Элементы a, у которых нет класса, сбрасываем до дефолтных стилей */\na:not([class]) {\n  text-decoration-skip-ink: auto;\n}\n\n/* Упрощаем работу с изображениями */\nimg {\n  max-width: 100%;\n  display: block;\n}\n\n/* Указываем понятную периодичность в потоке данных у article*/\narticle > * + * {\n  margin-top: 1em;\n}\n\n/* Наследуем шрифты для инпутов и кнопок */\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n/* Удаляем все анимации и переходы для людей, которые предпочитай их не использовать */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}","//tab sizes\n$tab-width: 60px;\n$not-active-tabs-width: 180px;\n\n//fonts colors\n$title-color: #191114;\n$sub-title-color: #140C0F;\n$footer-color: #323433;\n\n//tabs colors\n$aboutUs: #0085FF;\n$Business: #69B4FF;\n$News: #E0FFFF;\n$Contact: #70E072;\n$MessageSent: #A5F2A6;\n\n//def padding\n$mobile-tab-tablet-padding: 112px 24px 30px 24px;\n\n//def tab content styles\n@mixin selectedTablet {\n  cursor: default;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n}\n@mixin closeIcon {\n  position: fixed;\n  right: 30px;\n  top: 28px;\n  z-index: 2;\n}\n\n//transitions\n$tab-transition: width .5s ease-in-out;\n$left-content-transition-1: opacity .7s ease-in-out;\n$left-content-transition-2: opacity 3s ease-in-out;\n\n//fonts values\n$font-family-main: 'Inter', sans-serif;\n$font-family-title: 'Poppins', sans-serif;\n\n$font-w-400: 400;\n$font-w-700: 700;\n\n$font-size-13: 13px;\n$font-size-14: 14px;\n$font-size-16: 16px; //150%\n$font-size-18: 18px; //150%\n$font-size-20: 20px; // 150%\n$font-size-22: 22px;\n$font-size-24: 24px; //150%\n$font-size-32: 32px; //100%\n$font-size-48: 48px; //80%\n\n$font-size-179: 179px; //80%\n\n$font-line-150p: 150%;\n$font-line-100p: 100%;\n$font-line-80p: 80%;\n\n//font variants\n@mixin font-title-179 {\n  font-family: $font-family-title;\n  font-size: $font-size-179;\n  line-height: $font-line-80p;\n  font-weight: $font-w-700;\n}\n\n@mixin font-13 {\n  font-family: $font-family-main;\n  font-size: $font-size-13;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-14 {\n  font-family: $font-family-main;\n  font-size: $font-size-14;\n  line-height: 16px;\n  color: $sub-title-color;\n}\n\n@mixin font-16 {\n  font-family: $font-family-main;\n  font-size: $font-size-16;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-18 {\n  font-family: $font-family-main;\n  font-size: $font-size-18;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-20 {\n  font-family: $font-family-main;\n  font-size: $font-size-20;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-20-title {\n  font-family: $font-family-title;\n  font-size: $font-size-20;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-22 {\n  font-family: $font-family-title;\n  font-size: $font-size-22;\n  line-height: $font-line-80p;\n  color: $sub-title-color;\n}\n\n@mixin font-24 {\n  font-family: $font-family-main;\n  font-size: $font-size-24;\n  line-height: $font-line-150p;\n  color: $title-color;\n  font-weight: $font-w-400;\n}\n\n@mixin font-24-bold {\n  @include font-24;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-title-32 {\n  font-family: $font-family-title;\n  font-size: $font-size-32;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-title-48 {\n  font-family: $font-family-title;\n  font-size: $font-size-48;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
